import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PawSomeDelivery from "@/components/paw/PawSomeDelivery";

const API = process.env.REACT_APP_BACKEND_URL;
const absoluteUrl = (value) => !value ? "" : value.startsWith("http") ? value : `${API}${value}`;

export function resolveDeliveryPetName(report) {
  const deliveryReportName = String(report?.report_name || "").trim();
  const savedReportName = String(report?.creative_review?.pet_name || "").trim();
  const questionnaireNickname = String(report?.questionnaire?.text?.nicknames || "").trim();
  const approvedReportName = String(report?.approved_package?.pet_name || "").trim();
  const originalOrderName = String(report?.pet_name || "").trim();
  return deliveryReportName || savedReportName || questionnaireNickname || approvedReportName || originalOrderName || "Your Pet";
}

export default function DeliveryTestPage() {
  const [params] = useSearchParams();
  const orderNumber = params.get("order") || "";
  const requestedReportId = params.get("report") || "";
  const token = params.get("token") || "";
  const [delivery,setDelivery]=useState(null); const [error,setError]=useState("");

  useEffect(()=>{
    if(!orderNumber) return;
    let cancelled=false;
    const suffix = token ? `?token=${encodeURIComponent(token)}` : "";
    fetch(`${API}/api/public/delivery/${encodeURIComponent(orderNumber)}/${encodeURIComponent(requestedReportId)}${suffix}`).then(async response=>{if(!response.ok) throw new Error(`Report could not be loaded (${response.status}).`);return response.json();}).then(data=>{if(!cancelled)setDelivery(data);}).catch(err=>{if(!cancelled)setError(String(err.message||err));});
    return()=>{cancelled=true;};
  },[orderNumber, requestedReportId, token]);

  const report=useMemo(()=>delivery?.report||null,[delivery]);
  const selectedPhoto=useMemo(()=>{if(!report)return null;return (report.photos||[]).find(photo=>photo.photo_id===report.selected_photo_id)||(report.photos||[]).find(photo=>photo.selected_for_report)||(report.photos||[])[0]||null;},[report]);

  if(!orderNumber) return <div style={{padding:32,fontFamily:"Georgia, serif"}}><h1>Envelope Delivery Test</h1><p>Add an order number to the test URL: <strong>/delivery-test?order=ORDER-NUMBER</strong></p></div>;
  if(error) return <div style={{padding:32,fontFamily:"Georgia, serif"}}><h1>Envelope Delivery Test</h1><p>{error}</p></div>;
  if(!delivery||!report) return <div style={{padding:32,fontFamily:"Georgia, serif"}}>Loading delivery test…</div>;

  const reportImageUrl=absoluteUrl(report.report_image_url);
  const downloadUrl=absoluteUrl(report.download_url);
  const deliveryPetName=resolveDeliveryPetName(report);
  return <PawSomeDelivery petName={deliveryPetName} petPhotoUrl={absoluteUrl(selectedPhoto?.file_url)} reportImageUrl={reportImageUrl} downloadUrl={downloadUrl}/>;
}
